"use client";

import Button from "@/components/Button";
import { useCartActions, useCartItemCount } from "@/tools/medusa";
import classNames from "@/helpers/classNames";
import styles from "./styles.module.scss";

export interface CartButtonProps {
  className?: string;
}

const CartButton = ({ className }: CartButtonProps) => {
  const itemCount = useCartItemCount();
  const { toggleCart } = useCartActions();

  return (
    <span className={classNames(styles.cartButton, className)}>
      <Button
        onClick={toggleCart}
        ariaLabel={`Shopping cart${itemCount > 0 ? `, ${itemCount} items` : ""}`}
        icon="shoppingBagOpen"
        iconSize="xl"
        variant="content"
        size="none"
        iconHover={false}
      />
      {itemCount > 0 && <span className={styles.badge}>{itemCount}</span>}
    </span>
  );
};

export default CartButton;
